import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ListPlus } from 'lucide-react';
import { Card } from '../../ui/Card';
import { Badge } from '../../ui/Badge';
import { Button } from '../../ui/Button';
import { PermissionGate } from '../../PermissionGate';
import { practiceStatusVariant } from '../practice/PracticeDetailModal';
import { practiceMembers, requesterKindLabel, requesterName } from '../../../utils/practices';
import { Practice } from '../../../types/practice';
interface CoursePracticesCardProps {
  practices: Practice[];
  onAssign: () => void;
}

// Users of the course: the participants of the assigned practices, by practice
export function CoursePracticesCard({
  practices,
  onAssign
}: CoursePracticesCardProps) {
  const groups = practices.map(p => ({
    practice: p,
    members: practiceMembers(p)
  }));
  const total = groups.reduce((sum, g) => sum + g.members.length, 0);
  return <Card noHoverShadow data-id="element-1209" data-mp="30n4csy23rkgp">
      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3 mb-5" data-id="element-1210" data-mp="30nxma6sg4o2j">
        <div data-id="element-1211" data-mp="37fzv2qryinva">
          <h3 className="text-lg font-semibold text-seform-navy" data-id="element-1212" data-mp="37im3esmo97ek">
            Partecipanti <span className="text-slate-500 font-normal" data-id="element-1213" data-mp="3ce1ejctaop7a">· {total}</span>
          </h3>
          <p className="text-sm text-slate-500 mt-0.5" data-id="element-1214" data-mp="3hfqpksgip2vd">
            {practices.length} {practices.length === 1 ? 'pratica assegnata' : 'pratiche assegnate'}.
            Per modificare i partecipanti intervieni sulla singola pratica.
          </p>
        </div>
        <PermissionGate module="training" action="edit" data-id="element-1215" data-mp="2tov56gee59y5">
          <Button variant="flat" color="secondary" size="sm" startContent={<ListPlus className="h-4 w-4" data-id="element-1217" data-mp="2ym4pxiqu4xfn" />} onClick={onAssign} data-id="element-1216" data-mp="2tpebezuoi9wc">
            Assegna pratiche
          </Button>
        </PermissionGate>
      </div>

      {groups.length === 0 ? <p className="text-sm text-slate-500" data-id="element-1218" data-mp="25xfv21gdhocc">Nessuna pratica assegnata a questo corso.</p> : <div className="space-y-5" data-id="element-1219" data-mp="2awadv3ecbcwg">
          {groups.map(({
        practice,
        members
      }) => <section key={practice.id} className="rounded-xl border border-slate-200" data-id="element-1220" data-mp="22vunytm3nec2">
              <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 bg-slate-50/70 rounded-t-xl border-b border-slate-100" data-id="element-1221" data-mp="1xykqcqok3wd5">
                <div className="min-w-0" data-id="element-1222" data-mp="27o497wc9rq80">
                  <Link to={`/training/pratiche/${practice.id}/modifica`} className="inline-flex items-center gap-1 text-sm font-semibold text-seform-navy hover:text-seform-orange hover:underline" data-id="element-1223" data-mp="27p5vyy2ne15k">
                    {requesterName(practice)}
                    <ArrowUpRight className="h-3.5 w-3.5" data-id="element-1224" data-mp="1tyu0cp6utk9o" />
                  </Link>
                  <p className="text-xs text-slate-500" data-id="element-1225" data-mp="1oxd5pbeyqu1j">{requesterKindLabel(practice)}</p>
                </div>
                <div className="flex items-center gap-2" data-id="element-1226" data-mp="35auwwq9ymczz">
                  <Badge variant={practiceStatusVariant[practice.status]} size="sm" data-id="element-1227" data-mp="30duqge97788c">
                    {practice.status}
                  </Badge>
                  <span className="text-sm text-slate-600 tabular-nums" data-id="element-1228" data-mp="37vj5ahve3nzj">
                    {members.length} {members.length === 1 ? 'partecipante' : 'partecipanti'}
                  </span>
                </div>
              </div>
              {members.length === 0 ? <p className="px-4 py-3 text-sm text-slate-500" data-id="element-1229" data-mp="32yiyg4qpuh7d">Nessun partecipante indicato.</p> : <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 px-4 py-3" data-id="element-1230" data-mp="3qnve9ngjtnin">
                  {members.map(m => <li key={m.id} className="min-w-0" data-id="element-1231" data-mp="3hv072o7ithq8">
                      <p className={`text-sm truncate ${m.placeholder ? 'text-amber-700 italic' : 'font-medium text-slate-800'}`} data-id="element-1232" data-mp="3huif43rw5po4">
                        {m.name}
                      </p>
                      {m.email && <p className="text-xs text-slate-500 truncate" data-id="element-1233" data-mp="i7a443c6kody">{m.email}</p>}
                    </li>)}
                </ul>}
            </section>)}
        </div>}
    </Card>;
}